import { render, staticRenderFns } from "./DeleteBread.vue?vue&type=template&id=4d1ce269&"
import script from "./DeleteBread.vue?vue&type=script&lang=js&"
export * from "./DeleteBread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports